import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    display: flex;
    flex-direction: column;
    height: 100%;

    ${theme.respondUpTo(
      'md',
      css`
        width: 100%;
      `
    )}
    ${theme.respondTo(
      'md',
      css`
        width: 400px;
      `
    )}
  `
);
